/**
 * 今週の統計カードコンポーネント
 *
 * 今週の完了数、予定数、達成率を数値で表示する。
 * シンプルなリスト形式で統計情報を提供。
 *
 * Rails で言えば:
 * - app/views/dashboard/_weekly_stats.html.erb に相当
 *
 * @example
 * <WeeklyStats weeklyStats={stats} />
 */

import { TrendingUp } from 'lucide-react'
import type { WeeklyStat } from '@/types'

interface WeeklyStatsProps {
  /** 週間統計データ */
  weeklyStats: WeeklyStat[]
}

export function WeeklyStats({ weeklyStats }: WeeklyStatsProps) {
  // 週間の合計値を計算
  const totalCompleted = weeklyStats.reduce((sum, s) => sum + s.completed, 0)
  const totalScheduled = weeklyStats.reduce((sum, s) => sum + s.scheduled, 0)
  const achievementRate =
    totalScheduled > 0 ? Math.round((totalCompleted / totalScheduled) * 100) : 0

  return (
    <div className="bg-card border-border rounded-xl border p-4 sm:p-5">
      <h2 className="text-foreground mb-4 flex items-center gap-2 font-semibold">
        <TrendingUp className="text-primary h-5 w-5" />
        今週の統計
      </h2>

      {weeklyStats.length > 0 ? (
        <div className="space-y-3">
          {/* 完了数 */}
          <div className="flex justify-between">
            <span className="text-muted-foreground text-sm">完了数</span>
            <span className="font-medium">{totalCompleted}</span>
          </div>

          {/* 予定数 */}
          <div className="flex justify-between">
            <span className="text-muted-foreground text-sm">予定数</span>
            <span className="font-medium">{totalScheduled}</span>
          </div>

          {/* 達成率 */}
          <div className="flex justify-between">
            <span className="text-muted-foreground text-sm">達成率</span>
            <span className="text-primary font-medium">{achievementRate}%</span>
          </div>
        </div>
      ) : (
        <p className="text-muted-foreground py-4 text-center text-sm">
          データがありません
        </p>
      )}
    </div>
  )
}
